import script from "./wxGroupPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./wxGroupPreview.vue?vue&type=script&setup=true&lang=js"

import "./wxGroupPreview.vue?vue&type=style&index=0&id=22941fc2&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22941fc2"]])

export default __exports__